import React, { useState } from "react";
import { TextField, Button } from "@mui/material";

type FormData = {
  name: string;
  contactPerson?: string;
  email?: string;
  phone?: string;
  address?: string;
};

type Props = {
  initial?: FormData;
  onSubmit: (form: FormData) => Promise<void>;
  saving?: boolean;
};

const SupplierForm: React.FC<Props> = ({ initial, onSubmit, saving }) => {
  const [form, setForm] = useState<FormData>(initial || {
    name: "", contactPerson: "", email: "", phone: "", address: ""
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <TextField name="name" label="Name" value={form.name} onChange={handleChange} required fullWidth />
      <TextField name="contactPerson" label="Contact Person" value={form.contactPerson} onChange={handleChange} fullWidth />
      <TextField name="email" type="email" label="Email" value={form.email} onChange={handleChange} fullWidth />
      <TextField name="phone" label="Phone" value={form.phone} onChange={handleChange} fullWidth />
      <TextField name="address" label="Address" value={form.address} onChange={handleChange} fullWidth />
      <div className="flex justify-end">
        <Button type="submit" variant="contained" disabled={saving}>
          {saving ? "Saving..." : "Save"}
        </Button>
      </div>
    </form>
  );
};

export default SupplierForm;
